/* ============
 * Register account setup Transformer
 * ============
 *
 * The transformer for the account setup.
 */

import Transformer from './../transformer';

export default class AccountSetupTransformer extends Transformer {
  /**
   * Method used to transform a fetched account setup.
   *
   * @param accountSetup The fetched account setup.
   *
   * @returns {Object} The transformed accountSetup
   */
  static fetch(accountSetup) {
    return {
      firstName: accountSetup.first_name,
      lastName: accountSetup.last_name,
      email: accountSetup.email,
      businessRegistrationNumber: accountSetup.business_registration_number,
      password: accountSetup.password,
      passwordConfirmation: accountSetup.password_confirmation,
      planId: accountSetup.plan_id,
      organizationTypeId: accountSetup.organization_type_id,
      businessName: accountSetup.business_name,
      mobile: accountSetup.mobile,
      address: accountSetup.address,
      postalCode: accountSetup.postal_code,
      city: accountSetup.city,
      country: accountSetup.country,
    };
  }

  /**
   * Method used to transform a send accountSetup
   *
   * @param accountSetup The accountSetup to be send
   *
   * @returns {Object} The transformed accountSetup
   */
  static send(accountSetup) {
    return {
      password: accountSetup.password,
      password_confirmation: accountSetup.passwordConfirmation,
      plan: accountSetup.plan,
      planType: accountSetup.type,
      name: accountSetup.name,
      email: accountSetup.email,
      mobile: accountSetup.mobile,
      organization_type: accountSetup.organizationType,
      business_registration_number: accountSetup.businessRegistrationNumber,
      business_name: accountSetup.businessName,
      address: accountSetup.address,
      postal_code: accountSetup.postalCode,
      city: accountSetup.city,
      country: accountSetup.country,
      is_vat_registered: accountSetup.isVatRegistered,
      is_registered_business_enterprise: accountSetup.isRegisteredBusinessEnterprise,
      tos_accepted: accountSetup.tosAccepted,
      marketing_allowed: accountSetup.marketingAllowed,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/custom/accountSetup.js